module.exports = require("@swa-ui/application/src/Page/ErrorPage/ErrorPage.module.scss");